import { styled } from '@mui/material';

export const SmartLinksContainer = styled('div')`
  height: 100vh;
  display: flex;
  flexdirection: column;
  padding: 0;
  overflow: hidden;
  padding-top: 64px;
`;
